
import { Component, Vue, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import Message from '@/components/message.vue';
import UploadImg from '@/components/upload-img.vue';
import memberTable from './member-table.vue';
import productTable from './product-table.vue';
import previewImg from '@/components/previewImg.vue';
import { imgHost, host } from "@/utils/config"

import {
	activityPersonalPKRankingAppointMemberImport,
	popoverproductbyspeclist,
	activityPersonalPKRankingSave,
	activityPersonalPKRankingInfo
} from '@/api/toBApi';
import {
	productpopoverproductlist,
	productCategory
} from '@/api/supplier';

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		memberTable,
		productTable,
		UploadImg,
		previewImg,
		'slz-dialog': Dialog,
		'slz-message': Message,
	}
})


export default class PKRANKINGDETAILS extends Vue {

	private checkLoopBonus: any = (rule, value, callback) => {

		let type = this.formData.PKMetricType;
		let str = ['业绩', '业绩', '销量', '销量', '人数'][type - 1];
		let min = 0;
		let max = 0;

		if (type === 5) {
			min = 1;
			max = 1000;
		} else if (type === 4 || type === 3) {
			min = 1;
			max = 10000000;
		} else {
			min = 0.01;
			max = 10000000;
		}

		const {
			Threshold, RewardMoney, RewardType, RewardProductId
		} = value;

		if (!Threshold) {
			return '请设置' + str + '门槛';
		} else if (+Threshold < min || +Threshold > max) {
			return str + '请设置在' + min + '~' + max + '之间，' + (type == 1 || type == 2 ? '2位小数' : '整数');
		} else if ((RewardType == 0 || RewardType === 2) && !RewardMoney) {
			return '请设置奖金';
		} else if ((RewardType == 0 || RewardType === 2) && (+RewardMoney < 0.01 || +RewardMoney > 100000)) {
			return '奖金请设置在0.01~100000之间，2位小数';
		} else if ((RewardType == 1 || RewardType === 2) && !RewardProductId) {
			return '请选择商品';
		} else {
			return ''
		}

	};

	private checkRankBonus: any = (rule, value, callback) => {
		const { FirstRank, NextRank, RewardMoney, RewardType, RewardProductId } = value;
		if (!FirstRank || !NextRank) {
			return '请设置排名';
		} else if (+FirstRank > +NextRank) {
			return '请设置正确名次区间';
		} else if ((RewardType == 0 || RewardType === 2) && !RewardMoney) {
			return '请设置奖金';
		} else if ((RewardType == 0 || RewardType === 2) && (+RewardMoney < 0.01 || +RewardMoney > 100000)) {
			return '奖金请设置在0.01~100000之间，2位小数';
		} else if ((RewardType == 1 || RewardType === 2) && !RewardProductId) {
			return '请选择商品';
		} else {
			return '';
		}
	}

	private checkRankProduct: any = (rule, value, callback) => {
		const { FirstRank, NextRank, RewardMoney, RewardType, RewardProductId, Threshold } = value;

		let type = this.formData.PKMetricType;
		let str = ['业绩', '业绩', '销量', '销量', '人数'][type - 1];
		let min = 0;
		let max = 0;

		if (type === 5) {
			min = 1;
			max = 1000;
		} else if (type === 4 || type === 3) {
			min = 1;
			max = 10000000;
		} else {
			min = 0.01;
			max = 10000000;
		}

		if (!FirstRank || !NextRank) {
			return '请设置名次区间';
		} else if (+FirstRank > +NextRank) {
			return '请设置正确名次区间';
		} else if (!Threshold) {
			return '请设置' + str + '门槛';
		} else if (+Threshold < min || +Threshold > max) {
			return str + '请设置在' + min + '~' + max + '之间，' + (type == 1 || type == 2 ? '2位小数' : '整数');
		}else if ((RewardType == 0 || RewardType === 2) && !RewardMoney) {
			return '请设置奖金';
		} else if ((RewardType == 0 || RewardType === 2) && (+RewardMoney < 0.01 || +RewardMoney > 100000)) {
			return '奖金请设置在0.01~100000之间，2位小数';
		} else if ((RewardType == 1 || RewardType === 2) && !RewardProductId) {
			return '请选择商品';
		}else {
			return ''
		}
	}

	private checkPKRankingBonus : any = (rule, value, callback) => {
		let type = this.formData.PKRewardType;

		if (type === 1 || type === 2){
			const err = this.checkLoopBonus(rule, value);
			if (err){
				callback(new Error(err))
			}else{
				callback()
			}
		}
		if (type === 3){
			const err = this.checkRankBonus(rule, value);
			if (err){
				callback(new Error(err))
			}else{
				callback()
			}
		}
		if (type === 4){
			const err = this.checkRankProduct(rule, value);
			if (err){
				callback(new Error(err))
			}else{
				callback()
			}
		}
	}


	private uploadFileApi = host + '/api/file/upload?PlatForm=routuan&Path=File';
	private imgUrl = imgHost;
	private pageLoading = false;
	private currentUrl = '';
	private showPreview = false;

	private formData: any = {
		Id: '',// (int): PK榜活动Id,
		Name: '',// (string, optional): 活动名称,
		StartTime: '',// (Date, optional): 活动开始时间,
		EndTime: '',// (Date, optional): 活动结束时间,
		PKMemberType: '',// (int) = ['级别:1' or '指定代理:2']: PK代理类型,
		PKRoleGrades: [],// (Array[int], optional): PK代理类型--等级,
		ActivityPersonalPKRankingJoinPKMemberDtos: '',// (Array[ActivityPersonalPKRankingJoinPKMemberDto], optional): PK代理类型--指定代理,
		PKMetricType: '',// (int) = ['团队业绩:1' or '零售业绩:2' or '团队销量:3' or '零售销量:4' or '有效分享人数:5']: PK指标类型,
		PKEffectiveSharersType: '',// (int) = ['仅新用户:1' or '仅老用户:2' or '不限新老用户:3']: PK指标类型--有效分享人数类型,
		PKProductType: '',// (int) = ['全部商品:1' or '指定商品:2']: PK商品类型,
		ActivityPersonalPKRankingJoinPKProductDtos: [],// (Array[ActivityPersonalPKRankingJoinPKProductDto], optional): PK商品类型--指定商品,
		PKRewardType: 2,// (int) = ['循环奖金:1' or '阶梯奖金:2' or '排名奖金:3' or '实物奖励:4']: PK奖励类型,
		// ActivityPersonalPKRankingLoopBonusDto: {
		// 	LoopBonusId: '',// (int): 循环奖金Id,
		// 	Threshold: '',// (double, optional): 循环奖金--门槛,
		// 	RewardMoney: '',// (double, optional): 循环奖金--奖金
		// 	RewardType: 1,
		// 	RewardProductId: '',
		// 	RewardProductSpecId: '',
		// 	ProductName: '',
		// },//: '',// (ActivityPersonalPKRankingLoopBonusDto, optional): PK奖励类型--循环奖金,
		// ActivityPersonalPKRankingLadderBonusDtos: [
		// 	{
		// 		LadderBonusId: '',// (int): 阶梯奖金Id,
		// 		Threshold: '',// (double, optional): 阶梯--门槛,
		// 		RewardMoney: '',// (double, optional): 阶梯--奖金,
		// 		Level: '',// (int): 阶梯层级
		// 		ErrorText: '',
		// 		RewardType: 1,
		// 		RewardProductId: '',
		// 		RewardProductSpecId: '',
		// 		ProductName: '',
		// 	}
		// ],// (Array[ActivityPersonalPKRankingLadderBonusDto], optional): PK奖励类型--阶梯奖金,
		// ActivityPersonalPKRankingRankBonusDtos: [
		// 	{
		// 		RankBonusId: '',// (int): 排名奖金Id,
		// 		FirstRank: '',// (int, optional): 排名--第几名,
		// 		NextRank: '',// (int, optional): 排名--到第几名,
		// 		RewardMoney: '',// (double, optional): 排名--奖金,
		// 		Level: '',// (int): 阶梯层级
		// 		ErrorText: '',
		// 		RewardType: 1,
		// 		RewardProductId: '',
		// 		RewardProductSpecId: '',
		// 		ProductName: '',
		// 	}
		// ],// (Array[ActivityPersonalPKRankingRankBonusDto], optional): PK奖励类型--排名奖金,
		// ActivityPersonalPKRankingRankProductDtos: [
		// 	{
		// 		RankProductId: '',// (int): 实物奖金Id,
		// 		FirstRank: '',// (int, optional): 排名--第几名,
		// 		NextRank: '',// (int, optional): 排名--到第几名,
		// 		RewardProductId: '',// (int, optional): 排名--实物Id,
		// 		RewardProductSpecId: '',
		// 		Level: '',// (int): 阶梯层级
		// 		ProductName: '',
		// 		SpecValueDisplay: '',
		// 		ErrorText: '',
		// 		RewardType: 1,
		// 		Threshold: '',
		// 	}
		// ],// (Array[ActivityPersonalPKRankingRankProductDto], optional): PK奖励类型--实物奖励,
		ActivityPersonalPKRankingBonusDtos: [
			{
				BonusId: '',// (int): 奖励Id,
				FirstRank: '',// (int): 排名--第几名,
				NextRank: '',// (int): 排名--到第几名,
				Threshold: '',// (double): 指标门槛,
				RewardType: 0,// (int) = ['奖金:0' or '商品:1' or '奖金加商品:2'],
				RewardMoney: '',// (double): 排名--奖金,
				RewardProductId: '',// (int): 商品Id,
				RewardProductSpecId: '',// (int): 商品规格,
				Level: '',// (int): 阶梯层级,
				ProductName: '',// (string, optional): 实物奖励商品名称,
				SpecValue: '',// (string, optional): 实物奖励商品规格1,
				SpecValue2: '',// (string, optional): 实物奖励商品规格2,
				SpecValue3: '',// (string, optional): 实物奖励商品规格3,
				SpecValue4: '',// (string, optional): 实物奖励商品规格4,
				SpecValue5: '',// (string, optional): 实物奖励商品规格5,
				SpecValueDisplay: '',// (string, optional): 实物奖励商品规格展示
				ErrorText: '',
			}
		],
		EntrancePosterImgUrl: '',// (string, optional): PK榜入口海报图,
		EntrancePosterImgHeight: '',// (double): PK榜入口海报图高度,
		EntrancePosterImgWidth: '',// (double): PK榜入口海报图宽度,
		SharePosterBackGroundImgUrl: '',// (string, optional): PK榜分享海报背景图
		RuleShowType: 0,
		RuleText: '',
		RuleImgUrl: '',
		LongImgUrl: ''
	}
	private rules: any = {
		Name: [
			{ required: true, message: '请输入活动名称', trigger: 'change' }
		],
		StartTime: {
			required: true, message: '请完善活动时间', trigger: 'change'
		},
		EndTime: {
			required: true, message: '请完善活动时间', trigger: 'change'
		},
		PKMemberType: [
			{ required: true, message: '请设置PK代理', trigger: 'change' }
		],
		PKRoleGrades: [
			{ required: true, message: '请选择级别', trigger: 'change' }
		],
		ActivityPersonalPKRankingJoinPKMemberDtos: [
			{ required: true, message: '请导入代理', trigger: 'change' }
		],
		PKMetricType: [
			{ required: true, message: '请选择PK指标', trigger: 'change' }
		],
		PKEffectiveSharersType: [
			{ required: true, message: '请选择用户类型', trigger: 'change' }
		],
		PKProductType: [
			{ required: true, message: '请设置PK商品', trigger: 'change' }
		],
		ActivityPersonalPKRankingJoinPKProductDtos: [
			{ required: true, message: '请选择PK商品', trigger: 'change' }
		],
		PKRewardType: [
			{ required: true, message: '请设置PK奖励', trigger: 'change' }
		],
		// ActivityPersonalPKRankingLoopBonusDto: [
		// 	{ required: true, validator: this.checkLoopBonus, trigger: 'change' }
		// ],
		// ActivityPersonalPKRankingLadderBonusDtos: [
		// 	{ required: true, validator: this.checkLoopBonus, trigger: 'change' }
		// ],
		// ActivityPersonalPKRankingRankBonusDtos: [
		// 	{ required: true, validator: this.checkRankBonus, trigger: 'change' }
		// ],
		// ActivityPersonalPKRankingRankProductDtos: [
		// 	{ required: true, validator: this.checkRankProduct, trigger: 'change' }
		// ],
		ActivityPersonalPKRankingBonusDtos: [
			{ required: true, validator: this.checkPKRankingBonus, trigger: 'change' }
		],
		EntrancePosterImgUrl: [
			{ required: true, message: '请上传入口海报图', trigger: 'change' }
		],
		SharePosterBackGroundImgUrl: [
			{ required: true, message: '请上传PK榜分享海报背景图', trigger: 'change' }
		]
	}


	private uploadFile = {
		ExcelFilePath: '',
		ExcelFileName: ''
	}

	private selectPop = {
		show: false,
		loading: false,
		pageNo: 1,
		pageSize: 20,
		list: [],
		total: 0,
		keywords: '',
		selectData: [],
		categoryList: [],
		categoryId: ''
	}

	private selectSkuProductPop = {
		show: false,
		loading: false,
		pageNo: 1,
		pageSize: 20,
		list: [],
		total: 0,
		keywords: '',
		selectData: null,
		index: 0,
		key: ''
	}

	private numSupper = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

	private isCopy = false;
	private infoId = 0;

	@Watch('formData.EntrancePosterImgUrl')
	private entrancePosterImgUrlChange() {
		let url = this.formData.EntrancePosterImgUrl;
		if (!url) {
			this.formData.EntrancePosterImgWidth = 0;
			this.formData.EntrancePosterImgHeight = 0;
		} else {
			let image = new Image();
			image.onload = () => {
				this.formData.EntrancePosterImgWidth = image.width;
				this.formData.EntrancePosterImgHeight = image.height;
				console.log(this.formData.EntrancePosterImgWidth, this.formData.EntrancePosterImgHeight)
			}
			image.src = this.imgUrl + url;
		}
	}
	@Watch('formData.HeaderImgUrl')
	private headerImgUrlChange() {
		let url = this.formData.HeaderImgUrl;
		if (!url) {
			this.formData.HeaderImgWidth = 0;
			this.formData.HeaderImgHeight = 0;
		} else {
			let image = new Image();
			image.onload = () => {
				this.formData.HeaderImgWidth = image.width;
				this.formData.HeaderImgHeight = image.height;
			}
			image.src = this.imgUrl + url;
		}
	}

	private mounted() {
		const route: any = this.$route;
		if (route.query.id) {
			this.infoId = route.query.id;
			if (route.query.copy){
				this.isCopy = true;
			}
			this.getDetails(route.query.id);
		}
		this.getProductCategory();
	}

	/**
	 * 获取商品分类
	 */
	private async getProductCategory() {
		try {
			const res: any = await productCategory({
				Skip: 0,
				Take: 999999,
			});
			this.selectPop.categoryList = res.Result.Results.map(item => {
				return {
					value: item.Id,
					label: item.CategoryName
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	private async getDetails(id) {
		try {
			this.pageLoading = true;
			const res: any = await activityPersonalPKRankingInfo({ ActivityPersonalPKRankingId: id });
			res.Result.ActivityPersonalPKRankingBonusDtos.map(item => {
				item.ErrorText = '';
				return item;
			})

			if (res.Result.PKEffectiveSharersType === 0) {
				res.Result.PKEffectiveSharersType = undefined;
			}
			res.Result.ActivityPersonalPKRankingJoinPKProductDtos.map(item => {
				item.Id = item.ProductId;
				item.ImgUrlComplete = item.MainImgUrlValue;
				return item;
			})

			if (this.isCopy){
				res.Result.Id = 0;
				res.Result.StartTime = '';
				res.Result.EndTime = '';
			}

			for (let item in res.Result) {
				this.formData[item] = res.Result[item];
			}

		} catch (e) {
			console.log(e)
		} finally {
			this.pageLoading = false;
		}
	}

	private handleClearValidate(formName, keys) {
		let ref: any = this.$refs[formName];
		ref.clearValidate(keys)
	}


	//上传图片
	private beforeUploadExcel(e) {
		let fileTyle = e.name.split('.').pop();
		console.log(fileTyle)
		if (!['xls', 'xlsx'].includes(fileTyle.toLowerCase())) {
			this.$message.error('请上传正确格式的文件');
			return false;
		}
		this.pageLoading = true;
		this.uploadFile.ExcelFileName = e.name;
		return true;
	}
	private handleUploadExcelSuccess(e) {
		this.uploadFile.ExcelFilePath = e.Result[0];
		this.sureUpload();
	}
	private async sureUpload() {
		try {
			const res: any = await activityPersonalPKRankingAppointMemberImport(this.uploadFile);

			const {
				ActivityPersonalPKRankingJoinPKMemberDtos,
				DownloadToken,
				FailCount,
				SuccessCount
			} = res.Result;

			this.formData.ActivityPersonalPKRankingJoinPKMemberDtos = ActivityPersonalPKRankingJoinPKMemberDtos;

			this.$confirm(`导入完成，已成功导入${SuccessCount}人，失败${FailCount}人。`, '提示', {
				showConfirmButton: false,
				cancelButtonText: FailCount ? '下载失败数据' : '好的',
				type: 'warning',
				distinguishCancelAndClose: true
			}).then(() => {
			}).catch((e) => {
				console.log(e)
				if (FailCount && 'cancel' === e) {
					let url = `${location.origin}/pc/activityPersonalPKRanking/appointMemberImport/download?DownloadToken=${DownloadToken}`;
					window.open(url)
				}
			});

		} catch (e) {
			console.log(e)
		} finally {
			this.pageLoading = false;
		}
	}


	private handleAddItem() {
		this.formData.ActivityPersonalPKRankingBonusDtos.push({
			BonusId: '',
			FirstRank: '',
			NextRank: '',
			Threshold: '',
			RewardType: 0,
			RewardMoney: '',
			RewardProductId: '',
			RewardProductSpecId: '',
			Level: '',
			ProductName: '',
			SpecValue: '',
			SpecValue2: '',
			SpecValue3: '',
			SpecValue4: '',
			SpecValue5: '',
			SpecValueDisplay: '',
			ErrorText: '',
		})
	}
	private handleDeleteItem(index) {
		this.formData.ActivityPersonalPKRankingBonusDtos.splice(index, 1)
	}



	//删除指定代理
	private memberChange(list) {
		this.formData.ActivityPersonalPKRankingJoinPKMemberDtos = list;
	}

	//删除商品
	private productChange(list) {
		this.formData.ActivityPersonalPKRankingJoinPKProductDtos = list;
	}

	//PK商品-选择商品
	private handleAddProduct() {
		this.selectPop.show = true;
		this.selectPop.keywords = '';
		this.selectPop.pageNo = 1;
		this.selectPop.selectData = this.formData.ActivityPersonalPKRankingJoinPKProductDtos;
		this.getProductList();

		this.$nextTick(() => {
			let ref: any = this.$refs['selectPop'];
			this.selectPop.selectData.map(item => {
				ref.toggleRowSelection(item, true);
			})

		})
	}
	private handlePopSearch() {
		this.selectPop.pageNo = 1;
		this.getProductList();
	}
	private selectPopChangePage(e) {
		this.selectPop.pageNo = e;
		this.getProductList();
	}
	private handleSelectionChange(list) {
		this.selectPop.selectData = list;
	}
	private handleSelect() {
		if (!this.selectPop.selectData.length) {
			this.$message.error('请选择商品');
			return;
		}

		this.formData.ActivityPersonalPKRankingJoinPKProductDtos = this.selectPop.selectData;
		this.selectPop.show = false;
	}
	private async getProductList() {
		try {
			this.selectPop.loading = true;
			let params: any = {
				Skip: (this.selectPop.pageNo - 1) * this.selectPop.pageSize,
				Take: this.selectPop.pageSize,
				Keywords: this.selectPop.keywords.trim(),
				IsIncludeFinished: true,
				ProductCategoryId: this.selectPop.categoryId
			}
			const res: any = await productpopoverproductlist(params);
			this.selectPop.total = res.Result.Total;
			this.selectPop.list = res.Result.Results;
		} catch (e) {

		} finally {
			this.selectPop.loading = false;
		}
	}



	//选择实物奖励
	private handleAddSkuProduct(index) {

		this.selectSkuProductPop.index = index;
		this.selectSkuProductPop.show = true;
		this.selectSkuProductPop.keywords = '';
		this.selectSkuProductPop.pageNo = 1;

		let item = this.formData.ActivityPersonalPKRankingBonusDtos[index];

		if (item.RewardProductId) {
			this.selectSkuProductPop.selectData = {
				uid: item.RewardProductId + "" + item.RewardProductSpecId,
				Id: item.RewardProductId,
				ProductName: item.ProductName,
				SpecValueDisplay: item.SpecValueDisplay,
				SpecId: item.RewardProductSpecId
			}
			this.$nextTick(() => {
				let ref: any = this.$refs['selectSkuProductPop'];
				ref.toggleRowSelection(this.selectSkuProductPop.selectData, true);
			})

		} else {
			this.selectSkuProductPop.selectData = null;
		}

		this.getSkuProductList();


	}
	private handleSkuProductPopSearch() {
		this.selectSkuProductPop.pageNo = 1;
		this.getSkuProductList();
	}
	private selectSkuProductPopChangePage(e) {
		this.selectSkuProductPop.pageNo = e;
		this.getSkuProductList();
	}
	private handleSkuProductSelectionChange(bol, row) {
		this.selectSkuProductPop.list.map(item => {
			if (row.uid === item.uid) {
				item.checked = true;
			} else {
				item.checked = false;
			}
			return item;
		})
		this.selectSkuProductPop.selectData = row;
	}
	private handleSkuProductSelect() {
		if (!this.selectSkuProductPop.selectData) {
			this.$message.error('请选择商品');
			return;
		}


		let dt = this.formData.ActivityPersonalPKRankingBonusDtos[this.selectSkuProductPop.index];

		dt.RewardProductId = this.selectSkuProductPop.selectData.Id;
		dt.RewardProductSpecId = this.selectSkuProductPop.selectData.SpecId;
		dt.ProductName = this.selectSkuProductPop.selectData.ProductName;
		dt.SpecValueDisplay = this.selectSkuProductPop.selectData.SpecValueDisplay;
		dt.ErrorText = '';

		this.selectSkuProductPop.show = false;

		this.handleClearValidate('form4', ['ActivityPersonalPKRankingBonusDtos.' + this.selectSkuProductPop.index])
		
	}
	private async getSkuProductList() {
		try {
			this.selectSkuProductPop.loading = true;

			let params: any = {
				Skip: (this.selectSkuProductPop.pageNo - 1) * this.selectSkuProductPop.pageSize,
				Take: this.selectSkuProductPop.pageSize,
				Keywords: this.selectSkuProductPop.keywords.trim(),
				IsIncludeFinished: true,
			}
			const res: any = await popoverproductbyspeclist(params);
			this.selectSkuProductPop.total = res.Result.Total;
			this.selectSkuProductPop.list = res.Result.Results.map(item => {
				item.uid = item.Id + "" + item.SpecId;
				item.checked = this.selectSkuProductPop.selectData?.uid === item.uid ? true : false;
				return item
			});
		} catch (e) {

		} finally {
			this.selectSkuProductPop.loading = false;
		}
	}


	private rewardTypeChange() {
		this.formData.ActivityPersonalPKRankingBonusDtos = [
			{
				BonusId: '',
				FirstRank: '',
				NextRank: '',
				Threshold: '',
				RewardType: 0,
				RewardMoney: '',
				RewardProductId: '',
				RewardProductSpecId: '',
				Level: '',
				ProductName: '',
				SpecValue: '',
				SpecValue2: '',
				SpecValue3: '',
				SpecValue4: '',
				SpecValue5: '',
				SpecValueDisplay: '',
				ErrorText: '',
			}
		]
	}

	private checkMetricTypeIsDisabled() {
		if (!this.formData.PKMetricType) {
			this.$message.error('请先选择PK指标')
		}
	}

	private navBack() {
		this.$router.replace({
			name: 'soloRanking'
		})
	}
	private async handleSave() {
		await this.formValidate('form1');
		await this.formValidate('form2');
		await this.formValidate('form3');
		await this.formValidate('form4');

		if (this.formData.PKRewardType === 2) {
			let list = this.formData.ActivityPersonalPKRankingBonusDtos;
			let i = -1;
			list.map((item, index) => {
				if (index > 0 && +list[index - 1].Threshold >= +item.Threshold && i === -1) {
					i = index;
				}
				item.ErrorText = '';
				return item;
			})
			if (i > -1) {
				this.formData.ActivityPersonalPKRankingBonusDtos[i].ErrorText = '门槛需高于上一级阶梯';
				return;
			}
		}

		if (this.formData.PKRewardType === 3) {
			let list = this.formData.ActivityPersonalPKRankingBonusDtos;
			let index = -1;
			if (list.length > 1) {

				for (let i = 1; i < list.length; i++) {
					if (index === -1) {
						let item = list[i];

						list.map((prevItem, r) => {
							if (r < i) {

								let itemNum = [];
								let min = +prevItem.FirstRank;
								let max = +prevItem.NextRank;
								for (let n = min; n <= max; n++) {
									itemNum.push(n);
								}

								for (let m = +item.FirstRank; m <= +item.NextRank; m++) {
									if (itemNum.includes(m)) {
										index = i;
									}
								}
							}
						})


					}
				}
			}

			if (index > -1) {
				this.formData.ActivityPersonalPKRankingBonusDtos[index].ErrorText = '名次区间重叠，请重新配置';
				return;
			} else {
				this.formData.ActivityPersonalPKRankingBonusDtos.map(item => {
					item.ErrorText = '';
					return item;
				})
			}
		}


		if (this.formData.PKRewardType === 4) {
			let list = this.formData.ActivityPersonalPKRankingBonusDtos;
			let index = -1;
			let index1 = -1;
			if (list.length > 1) {

				for (let i = 1; i < list.length; i++) {
					if (index === -1) {
						let item = list[i];

						list.map((prevItem, r) => {
							if (r < i) {

								let itemNum = [];
								let min = +prevItem.FirstRank;
								let max = +prevItem.NextRank;
								for (let n = min; n <= max; n++) {
									itemNum.push(n);
								}

								for (let m = +item.FirstRank; m <= +item.NextRank; m++) {
									if (itemNum.includes(m)) {
										index = i;
									}
								}
							}
						})


					}
				}

				
				list.map((item, j) => {
					if (j > 0 && +list[j - 1].Threshold <= +item.Threshold && index1 === -1) {
						index1 = j;
					}
					item.ErrorText = '';
					return item;
				})
			}

			if (index > -1) {
				this.formData.ActivityPersonalPKRankingBonusDtos[index].ErrorText = '名次区间重叠，请重新配置';
				return;
			} else if (index1 > -1) {
				this.formData.ActivityPersonalPKRankingBonusDtos[index1].ErrorText = '指标门槛需低于上一级阶梯';
				return;
			} else {
				this.formData.ActivityPersonalPKRankingBonusDtos.map(item => {
					item.ErrorText = '';
					return item;
				})
			}
		}

		await this.formValidate('form5');

		this.saveData();
	}


	private async saveData() {
		try {
			this.pageLoading = true;
			this.formData.ActivityPersonalPKRankingBonusDtos.map((item, i) => {
				item.Level = i;
				return item;
			})
			this.formData.ActivityPersonalPKRankingJoinPKProductDtos.map(item => {
				item.ProductId = item.Id;
				return item;
			})
			const res: any = await activityPersonalPKRankingSave(this.formData)
			this.$message.success("操作成功");
			this.navBack();
		} catch (e) {
			console.log(e)
		} finally {
			this.pageLoading = false;
		}
	}

	private formValidate(formName: string) {
		return new Promise((resolve, reject) => {
			let ref: any = this.$refs[formName];
			ref.validate((valid) => {
				if (valid) {
					resolve(true);
				} else {
					setTimeout(() => {
						let query = document.querySelector('.el-form-item__error');
						console.log(query)
						query.scrollIntoView({ block: "center" });
					}, 500)
					this.$message.error('请完善活动配置');
					reject(false);
				}
			});
		})

	}

	private handlePreview(url) {
		this.showPreview = true;
		this.currentUrl = url;
	}
	private uploadSucess(list: any, key: string) {
		this.formData[key] = list[0]
	}

	private openDownload(url) {
		window.open(url)
	}


}
